import { Outlet } from "react-router-dom";
import { AppSidebar } from "./app-sidebar";
import { SidebarProvider, SidebarInset, SidebarTrigger } from "@/components/ui/sidebar";
import { Toaster } from "@/components/ui/sonner";
import { CelebrationProvider } from "@/components/celebrations";
import { HolidayDecorations, HolidayBannerSlot } from "@/components/holidays";

export function RootLayout() {
  return (
    <CelebrationProvider>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4">
            <SidebarTrigger className="-ml-1" />
          </header>
          <main className="flex-1 overflow-auto p-4 md:p-6">
            <HolidayBannerSlot />
            <Outlet />
          </main>
        </SidebarInset>
      </SidebarProvider>
      <HolidayDecorations />
      <Toaster />
    </CelebrationProvider>
  );
}
